<template>
    <div class="Header-menu">
        <div :class="[isBlack ? 'Header-menu-black' : 'Header-menu-white']" class="Header-menu-pc">
            <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" router>
                <el-menu-item v-for="(item, index) in menus" :key="item.path" :index="item.path">
                    {{ item.name }}
                </el-menu-item>
            </el-menu>
        </div>
        <div class="Header-menu-mobile flexAlign flex1">
            <div class="flexAlign" :class="[isBlack ? 'whiteIcon' : 'blackIcon']">
                <!-- <div @click="selectLang">
                    <img :src="require('@/assets/images/lang-white.png')" alt="">
                </div> -->
                <div :class="[isBlack ? 'Header-menu-black' : 'Header-menu-white']" class="menu-mobile">
                    <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" router>
                        <el-menu-item v-for="(item, index) in menusMobile" :key="item.path" :index="item.path">
                            {{ item.name }}
                        </el-menu-item>
                    </el-menu>
                </div>
                <div @click="toLogin">
                    <!-- <img :src="require('@/assets/images/user.png')" alt=""> -->
                    <img :src="require('@/assets/images/header/user.webp')" alt="">
                </div>
                <!-- <div @click="showAsideMenu()" type="primary">
                    <img :src="require('@/assets/images/menu.png')" alt="">
                    <img :src="require('@/assets/images/header/菜单.webp')" alt="">
                </div> -->
            </div>
            <el-drawer :lock-scroll="false" :append-to-body="true" :visible.sync="drawer" size="35%">
                <ul class="menu-list-box">
                    <li v-for="(item, index) in menus" :key="item.path" :index="item.path" @click="toPage(item.path)">
                        <div :class="activeTab == item.path ? 'activeTab' : ''">{{ item.name }}</div>
                    </li>
                </ul>
            </el-drawer>
        </div>
    </div>
</template>

<script>

export default {
    props: ['isBlack'],
    data() {
        return {
            activeIndex: this.$route.meta.activeMenu || this.$route.path,
            menus: [
                { name: this.$t('meun.home'), path: '/home' },
                { name: this.$t('meun.photovoltaic'), path: '/photovoltaic' },
                { name: this.$t('meun.energyManagement'), path: '/energyManagement' },
                { name: this.$t('meun.buyAndSellElectricity'), path: '/buyAndSellElectricity' },
                { name: this.$t('meun.operationsAndMaintenance'), path: '/operationsAndMaintenance' },
                { name: this.$t('meun.aboutUs'), path: '/aboutUs' },
                // { name: this.$t('meun.news'), path: '/news' },
                // { name: this.$t('meun.product'), path: '/product' },
                // { name: this.$t('meun.solution'), path: '/solution' },
            ],
            menusMobile: [
                // { name: this.$t('meun.home'), path: '/home' },
                { name: this.$t('meun.photovoltaic'), path: '/photovoltaic' },
                { name: this.$t('meun.energyManagement'), path: '/energyManagement' },
                { name: this.$t('meun.buyAndSellElectricity'), path: '/buyAndSellElectricity' },
                { name: this.$t('meun.operationsAndMaintenance'), path: '/operationsAndMaintenance' },
                { name: this.$t('meun.aboutUs'), path: '/aboutUs' },
            ],
            drawer: false,
            activeTab: '/home',
            currentLang: ''
        }
    },
    mounted() {
        this.currentLang = localStorage.getItem('lang') == 'en' ? 'English' : '中文'
    },
    methods: {
        showAsideMenu() {
            this.drawer = true
        },
        toPage(i) {
            this.$router.push({ path: i })
            this.drawer = false
            this.activeTab = i
        },
        toLogin() {
            window.open('https://new.huafune.com', '_blank');
        },
        selectLang() {
            if (this.currentLang == 'English') {
                this.$i18n.locale = 'zh'
                localStorage.setItem('lang', 'zh'); // 这样页面刷新就不会改变选择的语言了
                this.currentLang = '中文'

            } else {
                this.$i18n.locale = 'en'
                localStorage.setItem('lang', 'en'); // 这样页面刷新就不会改变选择的语言了
                this.currentLang = 'English'
            }
            window.location.reload()
        }
    },
    watch: {
        $route(val) {
            this.activeIndex = val.meta.activeMenu || val.path
        }
    }
}
</script>

<style lang="scss" scoped>
.Header-menu-black {
    .el-menu {
        background: none;
    }

    .el-menu.el-menu--horizontal {
        border: none;
    }

    .el-menu--horizontal>.el-menu-item {
        color: #cdc3c0;
        letter-spacing: 0.5px;
        font-weight: 400;
        font-size: 16px;
        font-family: 'PingFang SC';
    }

    .el-menu--horizontal>.el-menu-item.is-active {
        color: #ffffff;
        border-bottom: 2px solid #ffffff;
    }

    .el-menu--horizontal>.el-menu-item:not(.is-disabled):focus,
    .el-menu--horizontal>.el-menu-item:not(.is-disabled):hover,
    .el-menu--horizontal>.el-submenu .el-submenu__title:hover {
        background: none;
        color: #ffffff;
    }
}

.whiteIcon {
    img {
        width: 24px;
        color: #fff;
        margin-right: 10px;
    }
}

.blackIcon {
    img {
        width: 24px;
        color: black;
        margin-right: 10px;
    }
}

.activeTab {
    color: #609edf;
}

@media screen and (min-width: 980px) {
    .Header-menu-black {
        display: block
    }

    .Header-menu-pc {
        display: block
    }

    .Header-menu-mobile {
        display: none;
    }
}

@media screen and (max-width: 980px) {

    .Header-menu-black {
        display: none
    }

    .Header-menu-pc {
        display: none
    }

    .Header-menu-mobile {
        display: block;
    }

    .menu-mobile {
        margin: 0 auto;

        ::v-deep(.el-menu-item) {
            padding: 0 5px;
        }
    }
}
</style>
